const AppBar = {
  defaultProps: {},
  styleOverrides: {
    root: ({ theme }) => ({
      boxShadow: "none",
      backgroundColor: theme.palette.background.default,
    }),
  },
};

export default AppBar;
